import { render, staticRenderFns } from "./m-bujian-table.vue?vue&type=template&id=37906880&scoped=true&"
import script from "./m-bujian-table.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-bujian-table.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-bujian-table.vue?vue&type=style&index=0&id=37906880&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37906880",
  null
  
)

export default component.exports